module.exports = __webpack_public_path__ + "img/img17.142ff1a6.jpg";